import { render, staticRenderFns } from "./userPageTopBar.vue?vue&type=template&id=3bd8df4c&scoped=true"
import script from "./userPageTopBar.vue?vue&type=script&lang=js"
export * from "./userPageTopBar.vue?vue&type=script&lang=js"
import style0 from "./userPageTopBar.vue?vue&type=style&index=0&id=3bd8df4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8df4c",
  null
  
)

export default component.exports